export default "__VITE_ASSET__DjtHp$_g__"